export default class Policy {
  constructor (policy = {}) {
    Object.assign(this, policy)

    this.voyageList = policy.policyBeans.map(voyage => {
      return {
        ...voyage,
        voyageName: voyage.voyageName.replace(/\//g, '/<br/>'),
        qfPercent: (Math.min(voyage.qf, 1) * 100).toFixed(0) + '%'
      }
    })
  }
}